import Honeybadger from '@honeybadger-io/js';

export const configure = () => {
  return Honeybadger.configure({
    apiKey: process.env.NEXT_PUBLIC_HONEYBADGER_API_KEY || '',
    environment: process.env.NEXT_PUBLIC_HONEYBADGER_ENV || 'development',
    revision: process.env.NEXT_PUBLIC_HONEYBADGER_REVISION,
    projectRoot: 'turbopack:///[project]/qlab',
  });
};
